import { ArtworkMetadata } from "kreate-common/modules/business-types";

/**
 * If the metadata contain these keys and the corresponding value is
 * an empty string, we will treat them specially. In particular, we
 * will dictate the value of these keys.
 */
export const RESERVED_METADATA_KEYS = [
  "Artist",
  "Collection",
  "No. Editions",
] as const;

export const INITIAL_ARTWORK_METADATA: ArtworkMetadata = {
  entries: RESERVED_METADATA_KEYS.map((key) => ({ key, value: "" })),
};
